(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["icon-text"] && !Shopify.designMode) return;
  try {
    
// JavaScript opcional para efectos adicionales
class IconTextComponent {
  constructor() {
    this.init();
  }

  init() {
    // Puedes agregar aquí efectos adicionales con JavaScript si lo necesitas
    console.log('Icon Text Component loaded');
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new IconTextComponent();
  });
} else {
  new IconTextComponent();
}

  } catch(e) { console.error(e); }
})();
})();
